






























































































import { Component, Prop, Vue } from "vue-property-decorator";
import api from "@/api/index";
import PagedTableView from "@/components/PagedTableView/index.vue";
import { ExamSourceType } from "@/api/appService";


@Component({
  name: "UnselectedList",
  components: {
    PagedTableView,
  },
})
export default class UnselectedList extends Vue {
  @Prop() trainId?: number;
  @Prop() sourceType?: string;
  @Prop() ExamSourceType?: any

  queryForm = {
    question: undefined,
    questionType: undefined,
    trainId: undefined,
    sourceType: undefined
  };
  selectionList = [];

  totalScore=0;
  // 获取已选择数据
  getSelectionList(rows: any) {
    this.selectionList = rows;
  }

  fetchData(params: any) {
    api.examQuestion.getTrainQuestionDisplayOrderTotalScore({
      ...params,
      question: this.queryForm.question,
      questionType: this.queryForm.questionType,
      trainId: this.trainId,
      sourceType: this.sourceType,
      ExamSourceType: this.ExamSourceType
    }).then((res)=>{
      this.totalScore=res;
    })

    return api.examQuestion.getSelectedQuestionsByTrain({
      ...params,
      question: this.queryForm.question,
      questionType: this.queryForm.questionType,
      trainId: this.trainId,
      sourceType: this.sourceType,
      ExamSourceType: this.ExamSourceType
    });
  }

  handleUnSelected(item: any) {
    api.examQuestion.trainQuestionDelete({questionId: item.id,trainId:this.trainId}).then(res => {
      this.$message.success('操作成功');
      (this as any).$bus.$emit('refresh-data');
    });
  }

  // 批量删除
  handleBatchAdd() {
    if (!this.selectionList || this.selectionList.length <= 0) {
      this.$message({
        type: "error",
        message: "请至少选择一条要删除的试题",
      });
      return;
    }
    this.$confirm("确认批量删除试题吗?", "提示").then(async () => {
      let ids: any = [];
      this.selectionList.forEach((item: any) => {
        ids.push(item.id);
      });
      await api.examQuestion
        .trainQuestionBatchDeleteSave({body:{ questionIds: ids.join(','),trainId:this.trainId,sourceType:this.ExamSourceType }})
        .then((res: any) => {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    });
  }

  handleUpdateDisplayOrder(row: any) {
    api.examQuestion.updateTrainQuestionDisplayOrder({body:{id:row.trainExamQuestionId,displayOrder:row.displayOrder}}).then((res)=>{
      this.$message.success('操作成功');
      (this as any).$bus.$emit('refresh-data');
    })
  }
}
